import groq from 'groq';

export const CONSENT_CAPTURE = groq`
  consentCapture {
    variant,
    autoSubscribeMarketing
  }
`;
